import React, { useState, useEffect, useRef } from "react";
import "./css/Services.css";

const SERVICES = [
  {
    title: "Gardening",
    description:
      "Our gardening services include planting, weeding, pruning, and mulching. We can help you design and maintain a beautiful garden that will thrive in West Michigan's unique climate.",
    image: "/assets/more-eg-photos/fresh-landscape-backyard2.jpg",
    features: ["Custom planting designs", "Weeding & pruning", "Mulching & bed prep", "Seasonal color rotations"],
  },
  {
    title: "Maintenance",
    description:
      "We offer maintenance services to keep your garden looking its best. Our team provides regular care including trimming, fertilizing, and monitoring to ensure your garden stays healthy and vibrant.",
    image: "/assets/eg-images/maintenance1.JPG",
    features: ["Weekly/bi-weekly care", "Trimming & shaping", "Fertilization programs", "Pest monitoring"],
  },
  {
    title: "Seasonal Planters",
    description:
      "Our seasonal planter services create beautiful container gardens that add color and interest to your outdoor space throughout the year.",
    image: "/assets/eg-images/After H1 back corner.Final.jpg",
    features: ["Custom container designs", "Spring & summer displays", "Fall arrangements", "Holiday planters"],
  },
  {
    title: "Seasonal Service",
    description:
      "We provide seasonal cleanup services to prepare your garden for the changing seasons. Our team helps with debris cleanup, plant trimming, and garden preparation.",
    image: "/assets/more-eg-photos/curved-wall-plants.jpg",
    features: ["Spring cleanup", "Fall leaf removal", "Winter prep", "Bed renovation"],
  },
  {
    title: "Chemical Application",
    description:
      "Our certified staff handles everything from pesky weeds to unwanted organic matter. Professional-grade solutions applied safely and effectively.",
    image: "/assets/more-eg-photos/brick-path.jpg",
    features: ["Weed control", "Pest management", "Fertilizer application", "Licensed technicians"],
  },
];

export default function Services({ onQuoteClick }) {
  const [isVisible, setIsVisible] = useState({});
  const heroRef = useRef(null);
  const servicesRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const refs = [heroRef, servicesRef];
    refs.forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section
        id="services-hero"
        ref={heroRef}
        className={`services-hero ${isVisible["services-hero"] ? "visible" : ""}`}
      >
        <div className="services-hero-background">
          <img
            src="/assets/eg-images/flower-shovel.jpg"
            alt="Garden services"
          />
          <div className="services-hero-overlay" />
        </div>
        <div className="services-hero-content">
          <span className="section-label animate-fade-in-down">What We Do</span>
          <h1 className="services-hero-title animate-fade-in-up delay-1">
            Expert Garden Services
          </h1>
          <p className="services-hero-subtitle animate-fade-in-up delay-2">
            Comprehensive solutions for every aspect of your outdoor space,
            delivered with care and expertise.
          </p>
        </div>
      </section>

      {/* Services List */}
      <section
        id="services-list"
        ref={servicesRef}
        className={`services-list ${isVisible["services-list"] ? "visible" : ""}`}
      >
        <div className="services-list-container">
          <div className="services-intro">
            <h2>Serving West Michigan Since 2007</h2>
            <p>
              From routine maintenance to complete garden transformations, our
              experienced team brings passion and precision to every project.
            </p>
          </div>

          <div className="services-items">
            {SERVICES.map((service, index) => (
              <article
                key={service.title}
                className={`service-item ${index % 2 === 1 ? "reverse" : ""}`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="service-item-image">
                  <img src={service.image} alt={service.title} />
                  <div className="service-item-image-overlay" />
                </div>
                <div className="service-item-content">
                  <span className="service-number">0{index + 1}</span>
                  <h3 className="service-item-title">{service.title}</h3>
                  <p className="service-item-description">{service.description}</p>
                  <ul className="service-features">
                    {service.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                  <button
                    className="btn-primary-custom"
                    onClick={() => onQuoteClick(service.title)}
                  >
                    Request Service
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="services-cta-content">
          <h2>Not Sure What You Need?</h2>
          <p>
            Schedule a free consultation and we'll help you determine the best
            services for your property.
          </p>
          <button
            className="btn-primary-custom"
            onClick={() => onQuoteClick()}
          >
            Schedule Consultation
          </button>
        </div>
      </section>
    </div>
  );
}
